
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { Route } from 'vue-router';
import DateRange from '@/components/DateRange.vue';
import api from '@/api';
import Util from '@/utils/util';
import moment from 'moment';
import itemMixin from '@/minix/itemMixin';

const { report, invitationCode } = api;

async function getInvitationCodes() {
  const {
    data: { data },
  } = await invitationCode.list({ pageNo: 1, pageSize: 0 });
  return data.map((c: any) => c.invitationCode);
}

@Component({ components: { DateRange } })
export default class UserPointReport extends Mixins(Vue.extend(itemMixin)) {
  private data = {
    data: [],
    totalCount: 0,
    pageSize: 20,
    pageNo: 0,
  };

  private panel = 0;

  private loading = false;

  private headers = [
    { text: '註冊時間', align: 'center', value: 'registeredOn', width: 160 },
    { text: '會員編號', align: 'center', value: 'userId', width: 100 },
    { text: '會員外部ID', align: 'center', value: 'userIdPublic', width: 100 },
    { text: '會員姓名', align: 'center', value: 'fullName', width: 100 },
    { text: 'Email', align: 'center', value: 'email', width: 100 },
    { text: '國碼', align: 'center', value: 'countryCode', width: 100 },
    { text: '手機號碼', align: 'center', value: 'mobile', width: 160 },
    { text: '實名認證', align: 'center', value: 'authStatus', width: 100 },
    { text: '點數換入量', align: 'center', value: 'sumOfPointsIn', width: 100 },
    {
      text: '點數換出量',
      align: 'center',
      value: 'sumOfPointsOut',
      width: 100,
    },
    {
      text: '剩餘點數量',
      align: 'center',
      value: 'availablePoints',
      width: 100,
    },
    {
      text: '折價券<br>消費金額',
      align: 'center',
      value: 'paymentPriceWithDiscountCoupon',
      width: 100,
    },
    {
      text: '電支<br>消費金額',
      align: 'center',
      value: 'payAmount',
      width: 100,
    },
    { text: 'MGM人數', align: 'center', value: 'mgm', width: 100 },
    { text: '客戶來源', align: 'center', value: 'registerSource', width: 100 },
    {
      text: '註冊平台',
      align: 'center',
      value: 'registerPlatform',
      width: 100,
    },
    { text: '最後更新時間', align: 'center', value: 'modifiedOn', width: 160 },
  ];

  private platforms = [
    { text: 'Web', value: 1 },
    { text: 'Android', value: 2 },
    { text: 'iOS', value: 3 },
  ];

  private authStatuses = [
    { text: '一般會員', value: 0 },
    { text: '基本認證', value: 1 },
    { text: '實名認證', value: 2 },
  ];

  private registerSources = ['MGM'];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private filter = {
    userIdPublic: this.$route.query.userIdPublic || undefined,
    fullName: this.$route.query.fullName || undefined,
    email: this.$route.query.email || undefined,
    registerSource: this.$route.query.registerSource || undefined,
    userId: Util.isNullOrUndefined(this.$route.query.userId)
      ? undefined
      : this.$route.query.userId,
    registerPlatform: Util.isNullOrUndefined(this.$route.query.registerPlatform)
      ? undefined
      : +this.$route.query.registerPlatform,
    authStatus: Util.isNullOrUndefined(this.$route.query.authStatus)
      ? undefined
      : +this.$route.query.authStatus,
    startDate:
      this.$route.query.startDate === undefined
        ? this.getToday()
        : this.$route.query.startDate,
    endDate: this.$route.query.endDate || undefined,
    sumOfPointsInStart: Util.isNullOrUndefined(
      this.$route.query.sumOfPointsInStart,
    )
      ? undefined
      : +this.$route.query.sumOfPointsInStart,
    sumOfPointsInEnd: Util.isNullOrUndefined(this.$route.query.sumOfPointsInEnd)
      ? undefined
      : +this.$route.query.sumOfPointsInEnd,
    sumOfPointsOutStart: Util.isNullOrUndefined(
      this.$route.query.sumOfPointsOutStart,
    )
      ? undefined
      : +this.$route.query.sumOfPointsOutStart,
    sumOfPointsOutEnd: Util.isNullOrUndefined(
      this.$route.query.sumOfPointsOutEnd,
    )
      ? undefined
      : +this.$route.query.sumOfPointsOutEnd,
    availablePointsStart: Util.isNullOrUndefined(
      this.$route.query.availablePointsStart,
    )
      ? undefined
      : +this.$route.query.availablePointsStart,
    availablePointsEnd: Util.isNullOrUndefined(
      this.$route.query.availablePointsEnd,
    )
      ? undefined
      : +this.$route.query.availablePointsEnd,
    paymentPriceWithDiscountCouponStart: Util.isNullOrUndefined(
      this.$route.query.paymentPriceWithDiscountCouponStart,
    )
      ? undefined
      : +this.$route.query.paymentPriceWithDiscountCouponStart,
    paymentPriceWithDiscountCouponEnd: Util.isNullOrUndefined(
      this.$route.query.paymentPriceWithDiscountCouponEnd,
    )
      ? undefined
      : +this.$route.query.paymentPriceWithDiscountCouponEnd,
    payAmountStart: Util.isNullOrUndefined(this.$route.query.payAmountStart)
      ? undefined
      : +this.$route.query.payAmountStart,
    payAmountEnd: Util.isNullOrUndefined(this.$route.query.payAmountEnd)
      ? undefined
      : +this.$route.query.payAmountEnd,
    MGMStart: Util.isNullOrUndefined(this.$route.query.MGMStart)
      ? undefined
      : +this.$route.query.MGMStart,
    MGMEnd: Util.isNullOrUndefined(this.$route.query.MGMEnd)
      ? undefined
      : +this.$route.query.MGMEnd,
  };

  private pager = {
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private getToday() {
    return moment().format('yyyy-MM-DD');
  }

  private async updatePage(page: number) {
    await this.query(`${(this.pager.pageNo = page)}`);
  }

  private async query(page: string) {
    const pageNo = (typeof page === 'string' ? page : null) || `${this.pager.pageNo = 1}`;
    const query = {
      ...this.filter,
      userId: this.filter.userId ? `${this.filter.userId}` : undefined,
      registerPlatform: Number.isInteger(this.filter.registerPlatform)
        ? `${this.filter.registerPlatform}`
        : undefined,
      authStatus: Number.isInteger(this.filter.authStatus)
        ? `${this.filter.authStatus}`
        : undefined,
      pageSize: `${this.pager.pageSize}`,
      pageNo,
      sumOfPointsInStart: Number.isInteger(this.filter.sumOfPointsInStart)
        ? `${this.filter.sumOfPointsInStart}`
        : undefined,
      sumOfPointsInEnd: Number.isInteger(this.filter.sumOfPointsInEnd)
        ? `${this.filter.sumOfPointsInEnd}`
        : undefined,
      sumOfPointsOutStart: Number.isInteger(this.filter.sumOfPointsOutStart)
        ? `${this.filter.sumOfPointsOutStart}`
        : undefined,
      sumOfPointsOutEnd: Number.isInteger(this.filter.sumOfPointsOutEnd)
        ? `${this.filter.sumOfPointsOutEnd}`
        : undefined,
      availablePointsStart: Number.isInteger(this.filter.availablePointsStart)
        ? `${this.filter.availablePointsStart}`
        : undefined,
      availablePointsEnd: Number.isInteger(this.filter.availablePointsEnd)
        ? `${this.filter.availablePointsEnd}`
        : undefined,
      paymentPriceWithDiscountCouponStart: Number.isInteger(
        this.filter.paymentPriceWithDiscountCouponStart,
      )
        ? `${this.filter.paymentPriceWithDiscountCouponStart}`
        : undefined,
      paymentPriceWithDiscountCouponEnd: Number.isInteger(
        this.filter.paymentPriceWithDiscountCouponEnd,
      )
        ? `${this.filter.paymentPriceWithDiscountCouponEnd}`
        : undefined,
      payAmountStart: Number.isInteger(this.filter.payAmountStart)
        ? `${this.filter.payAmountStart}`
        : undefined,
      payAmountEnd: Number.isInteger(this.filter.payAmountEnd)
        ? `${this.filter.payAmountEnd}`
        : undefined,
      MGMStart: Number.isInteger(this.filter.MGMStart)
        ? `${this.filter.MGMStart}`
        : undefined,
      MGMEnd: Number.isInteger(this.filter.MGMEnd)
        ? `${this.filter.MGMEnd}`
        : undefined,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      userId: undefined,
      authStatus: undefined,
      registerPlatform: undefined,
      registerSource: undefined,
      userIdPublic: undefined,
      fullName: undefined,
      email: undefined,
      startDate: this.getToday(),
      endDate: undefined,
      sumOfPointsInStart: undefined,
      sumOfPointsInEnd: undefined,
      sumOfPointsOutStart: undefined,
      sumOfPointsOutEnd: undefined,
      availablePointsStart: undefined,
      availablePointsEnd: undefined,
      paymentPriceWithDiscountCouponStart: undefined,
      paymentPriceWithDiscountCouponEnd: undefined,
      payAmountStart: undefined,
      payAmountEnd: undefined,
      MGMStart: undefined,
      MGMEnd: undefined,
    };
    this.pager = {
      pageSize: 20,
      pageNo: 1,
    };
    await this.query('1');
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async exportCsv() {
    this.loading = true;
    const filter = { ...this.filter };
    const { status, data } = await report.exportUserPoint(filter);
    this.loading = false;
    if (status === 0) return;
    Util.saveFile(data, '行銷報表管理-會員點數列表.txt');
  }

  private setRegisterSources(sources: string[]) {
    this.registerSources = ['MGM', ...sources];
  }

  private async requestData() {
    this.loading = true;
    const filter = { ...this.filter, ...this.pager };
    const { status, data } = await report.userPoint(filter);
    this.loading = false;
    if (status === 1) {
      this.data = data;
    }
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: UserPointReport) => void) | boolean) => void,
  ) {
    const codes = await getInvitationCodes();

    await next(async (vm) => {
      vm.setRegisterSources(codes);
      await vm.requestData();
    });
  }
}
